module.exports = __webpack_public_path__ + "static/media/VIDAL_Vademecum_españa_FINAL.225b10a9.png";